import { vueSlideoutPanelService } from 'vue2-slideout-panel'

const Panel = {
  install (Vue, options) {
    Vue.prototype.$panel = function (component, props, width = 800) {
      return vueSlideoutPanelService.show({
        component,
        props,
        // disableBgClick: true,
        cssClass: 'slider-default',
        width: width + 'px'
      })
    }
  }
}

export default Panel



// WEBPACK FOOTER //
// ./src/plugins/panel.js